import React, { useState } from "react";

function InputNombrePatch({
    value,
    setValue,
    label = "Nombre del patch panel",
    placeholder = "pp1_ep_pb",
    title = "Respete la nomenclatura"
}) {
    const [error, setError] = useState("");

    const reglas = [
        /^[p]$/,        // 1
        /^[p]$/,        // 2
        /^[1-9]$/,      // 3
        /^[_]$/,        // 4
        /^[a-p]$/,      // 5
        /^[a-p]$/,      // 6
        /^[_]$/,        // 7
        /^[a-z]$/,      // 8
        /^[a-z0-9]$/    // 9
    ];

    const handleChange = (e) => {
        let inputValue = e.target.value.toLowerCase();

        // Solo permitir hasta 9 caracteres
        if (inputValue.length > 9) return;

        // Validar cada carácter según su posición
        for (let i = 0; i < inputValue.length; i++) {
            const char = inputValue[i];
            if (!reglas[i].test(char)) {
                setError(`Carácter inválido en posición ${i + 1}`);
                return;
            }
        }

        setError(""); // Si todo está bien, limpia el error
        setValue(inputValue);
    };

    return (
        <div className="form-group">
            <label>{label}</label>
            <input
                className={`input ${error ? "input-error" : ""}`}
                type="text"
                maxLength={9}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                title={title}
            />
            {error && <small className="error-text">{error}</small>}
        </div>
    );
}

export default InputNombrePatch;